module.exports = __webpack_public_path__ + "files/4cf21a699f33b597f575272267339e9e.png";